import { render } from "./Notifications.vue?vue&type=template&id=252d9928&scoped=true&ts=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=252d9928&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252d9928"]])

export default __exports__